class SignupPopup extends HTMLElement {
  static STORAGE_KEY = 'felds-seasonals:signup-popup-dismissed-until';

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('[data-signup-popup-close]');

    this.closeButton?.addEventListener('click', () => this.dismiss());
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dismiss();
    });
    this.dialog?.addEventListener('cancel', () => this.recordDismissal());

    if (this.dataset.forceOpen === 'true') {
      this.open();

      if (this.dataset.postedSuccessfully === 'true') {
        this.recordDismissal(365);
      }

      return;
    }

    if (this.isSnoozed()) return;

    const delaySeconds = parseInt(this.dataset.delay, 10) || 0;
    this.timeout = setTimeout(() => this.open(), delaySeconds * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this.timeout);
  }

  isSnoozed() {
    const until = Number(window.localStorage.getItem(SignupPopup.STORAGE_KEY));
    return Boolean(until) && Date.now() < until;
  }

  open() {
    if (this.dialog && !this.dialog.open) this.dialog.showModal();
  }

  dismiss() {
    this.recordDismissal();
    this.dialog?.close();
  }

  recordDismissal(days) {
    const frequencyDays = days || parseInt(this.dataset.frequencyDays, 10) || 14;
    const until = Date.now() + frequencyDays * 24 * 60 * 60 * 1000;
    window.localStorage.setItem(SignupPopup.STORAGE_KEY, String(until));
  }
}

customElements.define('signup-popup', SignupPopup);
